
import { React, useState, useEffect, useContext } from 'react';
import UserContext from '../components/User_Context.js';
import { useNavigate, Navigate, useParams } from 'react-router-dom';
import * as api from "../api/apiConnector.js";

function Logout_Screen(params) {
    const { doLogout } = useContext(UserContext);
    const navigate = useNavigate();
    const { currentUser } = useContext(UserContext);

    const logout = async () => {
        let currentUsername;
const currentUserFromToken = currentUser();
        if (currentUserFromToken.UserName) {
            currentUsername = currentUserFromToken.UserName
        }
        var logoutURL = await api.sendMessage("security/oauthLogout", {
            
            body: {
                currentUsername:currentUsername
            }
        });
        var result = await doLogout();





        if (logoutURL && logoutURL.url && logoutURL.url != '') {
            document.location.href = logoutURL.url;
        } else {
            document.location.href = "/";

        }


    }

    useEffect(() => {
        logout();
    }, []);

    return (<></>);
}

export { Logout_Screen }